import { FormattedMessage } from "react-intl";
import type { ReactNode } from "react";

import Button from "common/core/button";
import { Hr } from "common/core/horizontal_rule";
import Tooltip from "common/core/tooltip";

import Styles from "./index.module.scss";

export function Footer({
  loading,
  tooltipText,
  step,
}: {
  loading: boolean;
  tooltipText: ReactNode;
  step: string;
}) {
  return (
    <>
      <Hr />
      <div className={Styles.wrapper}>
        <Tooltip
          placement="bottom"
          targetClassName={Styles.tooltipButton}
          target={
            <FormattedMessage
              id="d8dc8780-8137-4122-8e88-4ccbba73b884"
              defaultMessage="Why do we need this?"
            />
          }
        >
          {tooltipText}
        </Tooltip>

        <Button
          type="submit"
          variant="primary"
          buttonColor="action"
          isLoading={loading}
          data-pendo-id={`title-onboarding-save-${step}`}
        >
          <FormattedMessage
            id="388d0bac-57fc-4a38-b033-d97c520d40ca"
            defaultMessage="Save and continue"
          />
        </Button>
      </div>
    </>
  );
}
